import { Box, Paper } from "@mui/material";
import React from "react";
import { temp } from "../../../../interfaces/interfaces";
import { isDev } from "@utils/general";
import { FormHandlerObject } from "@utils/general/interfaces";
import DeleteButtonBR from "../../DeleteIconBR";
import HouseButtonBR from "../../HouseIconBR";
import HouseButtonPF from "../../HouseIconPF";
import { AddressPrefix } from "@utils/BasicTypes";

const name = "ActionButtons";

interface ActionButtonsProps {
    prefix: AddressPrefix;
    asProperty?: boolean;
    form: FormHandlerObject;
    parent: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ prefix, asProperty, form, parent }) => {

    const debugName = `${parent}▷[${name}]`

    return (
        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", position: "relative", bottom: "4rem", mb: "-4rem !important" }}>
            <Paper elevation={1} sx={{ p: .5, borderRadius: ".5rem", position: "relative" }}>
                <HouseButtonBR parent={debugName} tooltip="Select Address" prefix={prefix} disabledBtn={asProperty} />
                {isDev() && <HouseButtonPF parent={debugName} tooltip="Generate Address" prefix={prefix} disabledBtn={asProperty} />}
                <DeleteButtonBR parent={debugName} tooltip="Clear Form" action={React.useCallback(() => { form.clear(prefix); (temp[`${prefix}ActiveSearch`] as boolean) = false }, [form, prefix])} disabledBtn={asProperty} />
            </Paper>
        </Box>
    );
}

ActionButtons.displayName = name;

export default ActionButtons;